import React from 'react'

import { Link } from '@afterpaytouch/core'
import { Trans } from 'next-i18next'
import { AssetLayout } from '.'
import {
  PostCaptureHeader,
  Progress,
  Subtitle,
  HeroTitle,
  Image,
  PrimaryTitle,
  SecondaryTitle,
  CallToAction,
  ThankYou,
  FinePrint,
  FooterLink,
} from './component'
import { PostCheckoutFlow } from '../../model'
import { useConsumerSelector, useMerchantDisplayNameOrName } from '../../state'

import styles from './styles.module.css'
import clsx from 'clsx'
import { useSurveyUIConfig } from '../../utils/post-checkout'
import { getImageReservedSpaceClassName } from './imageReservedSpace'

export const Survey: AssetLayout = ({
  actioned,
  assetId,
  flow,
  showProgressBar,

  primaryTitle = '',
  heroTitle = '',
  secondaryTitle = '',
  thankyouTitle = '',
  finePrint = '',
  privacyPolicyUrl = '',
  selectedOption = '',
  footerLinkTitle = '',
  postCaptureConfirmTitle = '',
  postCaptureConfirmDescription = '',
  disabled = false,

  onPrimaryActionClick = () => {},
  onNegativeActionClick = () => {},
  onSkipActionClick = () => {},
}) => {
  const { email } = useConsumerSelector()
  const merchantName = useMerchantDisplayNameOrName()
  const cardStyle = clsx([styles.assetPaddedCard, styles.assetPaddingLarge])
  const { showImage } = useSurveyUIConfig()
  const imageClassName = getImageReservedSpaceClassName(assetId)

  return (
    <>
      <PostCaptureHeader
        title={postCaptureConfirmTitle}
        description={
          <Trans
            i18nKey={postCaptureConfirmDescription}
            tOptions={{ email, merchantName }}
            components={{
              merchantLink: <Link onClick={onSkipActionClick} kind='Underline' />,
            }}
          />
        }
        show={flow === PostCheckoutFlow.PostCapture}
      />
      <Progress show={flow === PostCheckoutFlow.PreCapture} visible={showProgressBar} />
      <Subtitle />
      <div className={cardStyle}>
        <HeroTitle label={heroTitle} />
        <Image alt={primaryTitle} show={showImage} reservedSpaceClassName={imageClassName} />
        <PrimaryTitle show={!actioned} label={primaryTitle} />
        <SecondaryTitle show={!actioned} label={secondaryTitle} />
        <CallToAction
          show={!actioned}
          id={assetId}
          buttonType='radio'
          onPrimaryActionClick={onPrimaryActionClick}
          onNegativeActionClick={onNegativeActionClick}
          testNameSpace='postCheckout-cta'
          disabled={disabled}
        />
        <ThankYou show={actioned} selected={selectedOption} label={thankyouTitle} />
        <FinePrint label={finePrint} privacyUrl={privacyPolicyUrl} />
      </div>
      <FooterLink disabled={disabled} onClick={onSkipActionClick}>
        {footerLinkTitle}
      </FooterLink>
    </>
  )
}
